import { colors } from "colors"
import { StyleSheet } from "react-native"
import { typography } from "theme"

export const style = StyleSheet.create({
  buttonContainer: { alignItems: "center", flex: 1, justifyContent: "flex-end", marginBottom: 30 },
  cell: {
    borderColor: colors.inputFieldBorder,
    borderRadius: 10,
    borderWidth: 1,
    fontSize: 24,
    height: 40,
    lineHeight: 33,
    textAlign: "center",
    width: 40,
  },
  container: { height: "100%", marginHorizontal: 10 },
  errorCell: {
    borderColor: colors.error,
  },
  fieldTitle: {
    fontFamily: typography.primary.normal,
    fontSize: 12,
    fontWeight: "600",
    marginBottom: 6,
    marginTop: 10,
    paddingLeft: 4,
  },
  flex: { flex: 1 },
  forgetPinText: {
    alignSelf: "flex-end",
    fontFamily: typography.primary.normal,
  },
  loginButton: { marginBottom: 10 },
  logoImage: {
    flex: 1,
    height: null,
    margin: 20,
    resizeMode: "contain",
    width: null,
  },
  mb10: { marginBottom: 10 },
  mv30: { marginVertical: 20 },
  phoneNumberInputContainer: { alignSelf: "center", marginTop: 0 },
  phoneNumberInputStyle: {
    height: 50,
    paddingLeft: 10,
    paddingVertical: 10,
    width: "100%",
  },
  titleText: { fontFamily: typography.primary.normal, fontSize: 23, marginBottom: 10 },
  inputContainer: { 
    alignSelf: "center", 
    marginTop: 10, 
  },
  inputStyle: {
    height: 50,
    paddingLeft: 10,
    paddingVertical: 10,
    width: "100%",
    borderColor: colors.inputFieldBorder,
  },
})
